{
  "ranges": {
    "mouseSensitivity": {
      "min": 0.25,
      "max": 3,
      "step": 0.05
    },
    "masterVolume": {
      "min": 0,
      "max": 1,
      "step": 0.05
    },
    "musicVolume": {
      "min": 0,
      "max": 1,
      "step": 0.05
    },
    "sfxVolume": {
      "min": 0,
      "max": 1,
      "step": 0.05
    },
    "uiVolume": {
      "min": 0,
      "max": 1,
      "step": 0.05
    },
    "commsVolume": {
      "min": 0,
      "max": 1,
      "step": 0.05
    },
    "hullEffect": {
      "min": 0,
      "max": 1,
      "step": 0.05
    },
    "uiScale": {
      "min": 0.75,
      "max": 2,
      "step": 0.05
    }
  },
  "menuNav": {
    "repeatDelay": 0.4,
    "repeatInterval": 0.09,
    "stickThreshold": 0.6,
    "stickRelease": 0.35
  }
}
